import { render, staticRenderFns } from "./Clinics.vue?vue&type=template&id=36cfdbd3&scoped=true"
import script from "./Clinics.vue?vue&type=script&lang=ts"
export * from "./Clinics.vue?vue&type=script&lang=ts"
import style0 from "./Clinics.vue?vue&type=style&index=0&id=36cfdbd3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cfdbd3",
  null
  
)

export default component.exports